module.exports = __webpack_public_path__ + "img/icon-step@3x2.85eae0e0.png";